import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getWishlistAsync,
  saveConfig,
  selectConfig,
  selectsortValue,
  setSortValue
} from './store/wishlist/wishlistSlice';
import { getLabels } from '@utils/utils';
import { GlobalMethods } from './interfaces/global';
import { AppDispatch } from './store/store';
import Wishlist from '@components/wishlist/Wishlist';
import wishlistMock from './moks/wishlistMock.json';
import { WISHLIST_PAGE_SIZE } from '@utils/const';

declare global {
  interface Window {
    tealium_data2track: any[];
    globalMethods: any;
  }
}

export default ({ data }) => {
  const dispatch: any = useDispatch<AppDispatch>();

  const [isKeyboardUser, setIsKeyboardUser] = useState(false);

  const config = useSelector(selectConfig);
  const sortValue = useSelector(selectsortValue);


   /*
    globalMethods - object that contains all the function called from the functions defined in
    'callFromComponentToTO' object in config object.
  */
    const globalMethods = {
      changeSort: (value) => {
        let valueSort;
        switch (value) {
          case 'sort_last':
            valueSort = 1;
            break;
          case 'sort_first':
            valueSort = 2;
            break;
          case 'sort_low':
            valueSort = 3;
            break;
          case 'sort_high':
            valueSort = 4;
            break;
          default:
            valueSort = 1;
            break;
        }
        dispatch(setSortValue(valueSort));
      }
    };
  
    window.globalMethods = globalMethods; 

  /* At first render, save the config, get labels */
  useEffect(() => {
    getLabels(data.langUrl);

    dispatch(saveConfig(data));
    dispatch(getWishlistAsync({ pageNumber: 1, pageSize: WISHLIST_PAGE_SIZE, sortValue: sortValue }));

    //attach events for 'Tab' navigation
    window.addEventListener('keydown', setKeyboardUser);
    window.addEventListener('mousedown', unsetKeyboardUser);
  }, []);

  useEffect(() => {
    if(!!sortValue) {
      dispatch(getWishlistAsync({ pageNumber: 1, pageSize: WISHLIST_PAGE_SIZE, sortValue: sortValue }));
    }
  }, [sortValue])

  // for accessibility
  const setKeyboardUser = (e: KeyboardEvent) => {
    if (e.code === 'Tab') {
      setIsKeyboardUser(true);
    }
  };

  const unsetKeyboardUser = () => {
    setIsKeyboardUser(false);
  };

  return (
    <div id="saved-items" className={`saved-items${isKeyboardUser ? ' isKeyboardUser' : ''}`}>
      {config !== null && <Wishlist />}
    </div>
  );
};
